// Load Styles
import '../scss/main.scss';

import '../../node_modules/slick-carousel/slick/slick.css';
import '../../node_modules/slick-carousel/slick/slick-theme.css';

import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'
import AOS from 'aos';
import 'aos/dist/aos.css';
import WOW from 'wowjs';
import 'wowjs/css/libs/animate.css'
// Load Bootstrap init

global.$ = require("jquery");
global.jQuery = global.$;
import { initBootstrap } from "./bootstrap";


// initBootstrap({
//     tooltip: true,
//     popover: true,
//     toasts: true,
// });


require('../../node_modules/slick-carousel/slick/slick.min.js');
require('../../node_modules/slick-carousel/slick/fonts/slick.ttf');
require('../../node_modules/slick-carousel/slick/fonts/slick.woff');
require('../../node_modules/slick-carousel/slick/ajax-loader.gif');

//const WOW = require('wowjs');

//const WOW = require('wowjs');

window.wow = new WOW.WOW({
    live: true
});

AOS.init({
    disable: function() {
      var maxWidth = 800;
      return window.innerWidth < maxWidth;
    }
  });
  //require('./custom.js');
  
  // $(window).on("load", function () {
  //   $("body").addClass("loaded");
  // });

  $(function () {
    $("body").addClass("loaded");
    console.log("document is ready");
  });

